<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
<mat-list>
  <mat-list-item *ngFor="let cam of data; let i = index">
    <div class="share-item">
      <div>
        {{ cam.name }}
      </div>
      <sn-icon-button (click)="data.splice(i, 1)"
        ><sn-icon fontSet="fal" fontIcon="fa-close"></sn-icon
      ></sn-icon-button>
    </div>
  </mat-list-item>
</mat-list>
<mat-dialog-actions>
  <button mat-button color="danger" mat-dialog-close>Cancel</button>
  <button mat-button color="success" (click)="save()">Create Shares</button>
</mat-dialog-actions>
